declare interface WebSocket {
    readonly CLOSED: number;
    readonly CLOSING: number;
    readonly CONNECTING: number;
    readonly OPEN: number;
}
declare var WebSocket: {
    readonly CLOSED: number;
    readonly CLOSING: number;
    readonly CONNECTING: number;
    readonly OPEN: number;
};
export type WebSocketStatus =
    | WebSocket['OPEN']
    | WebSocket['CONNECTING']
    | WebSocket['CLOSING']
    | WebSocket['CLOSED'];

export function webSocketStatusString(s: WebSocketStatus) {
    return {
        [WebSocket.OPEN]: 'connected',
        [WebSocket.CONNECTING]: 'connecting',
        [WebSocket.CLOSING]: 'closing',
        [WebSocket.CLOSED]: 'closed'
    }[s];
}
